import { render, staticRenderFns } from "./AutoUploadUrl.vue?vue&type=template&id=4f89f0e6&scoped=true"
import script from "./AutoUploadUrl.vue?vue&type=script&lang=js"
export * from "./AutoUploadUrl.vue?vue&type=script&lang=js"
import style0 from "./AutoUploadUrl.vue?vue&type=style&index=0&id=4f89f0e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f89f0e6",
  null
  
)

export default component.exports